/* eslint-disable react-hooks/exhaustive-deps */
import { Calculator } from '@climatetradecarbon/climatetrade-calculator'
import {
  Blur,
  Box,
  Button,
  Loader,
  Text
} from '@climatetradecarbon/climatetrade-components'
import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'
import { useAppDispatch } from 'src/app/hooks'
import { Pack } from 'src/core/models/pack'
import { trackEvent } from 'src/features'
import { apiFetcher } from 'src/lib/api/data'
import { API_PACKS_PATH } from 'src/lib/constants/routes'
import { capitalize } from 'src/lib/utils'

/**
 * Calculator component
 *
 * @description This components renders a back button, the calculator fetched according to name passed as props,
 * the breadcrumbs and the contact scene. Besides renders a loader while the calculator is being fetched.
 *
 * @returns {JSX.Element} The calculator scene
 */
export default function CalculatorComponent({
  name,
  onClose
}: {
    name: string
    onClose: () => void
}) {
  // Get the translation function and the current language
  const { t, i18n } = useTranslation()

  // The pack state to store the calculator pack
  const [pack, setPack] = useState<Pack>()

  // Loading state to show/hide the loader
  const [loading, setLoading] = useState<boolean>(false)
  const { route } = useRouter()
  const dispatch = useAppDispatch()
  /**
     * Fetch the calculator pack from the API as soon as the component is mounted
     */
  useEffect(() => {
    const fetchPack = async () => {
      // Set loading to true to display the loader
      setLoading(true)
      // URL endpoint to get a specific calculator pack matching the name in the params
      const url = `${API_PACKS_PATH}/?name=${capitalize(name)}`
      // The api fetcher returns a promise with data inside the response object
      const { data } = await apiFetcher(url)
      // Set the pack to the data returned from the api
      setPack(data)
      // Set loading to false to hide the loader
      setLoading(false)
    }

    fetchPack()
  }, [])

  return loading ? (
    <Blur>
      <Loader />
    </Blur>
  ) : (
    <Box direction='vertical'>
      <Button
        variant='back'
        onClick={onClose}
      >
        {t('general.GoBackToList')}
      </Button>

      <Text variant='h3'>{pack?.title[i18n.language || 'en']}</Text>

      {pack && (
        <Calculator
          pack={pack.name}
          language={i18n.language}
          onResultChange={() => {
            dispatch(trackEvent(route, 'STEP_VIEW', 'CALCULATION_FINISHED'))
          }}
          onEquivalenceChange={() => undefined}
        />
      )}
    </Box>
  )
}
